import { AbstractControl, ValidationErrors } from '@angular/forms';
import BigNumber from 'bignumber.js';
import { validationConstants } from './validation-utils';

export class ValidatorUtils {
  static compareBigNumbers(matchTo: string): ValidationErrors {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.parent && c.value) {
        if (!isNaN(c.value)) {
          if (
            !new BigNumber(c.value)
              .multipliedBy(new BigNumber(10).pow(12))
              .isLessThanOrEqualTo(new BigNumber(matchTo))
          ) {
            return {
              maxNumber: new BigNumber(matchTo)
                .dividedBy(new BigNumber(10).pow(12))
                .toString(),
            };
          }
        }
      }
      return null;
    };
  }

  static validateEmail(c: AbstractControl): ValidationErrors | null {
    if (c.value) {
      const valid = validationConstants.emailRegex.test(c.value);
      return valid ? null : { invalidEmail: 'invalidEmail' };
    }
    return null;
  }

  static validateDecimal(c: AbstractControl): ValidationErrors | null {
    if (c.value) {
      const valid = validationConstants.numberRegex.test(c.value);
      return valid ? null : { invalidDecimal: 'invalidDecimal' };
    }
    return null;
  }

  static minBigNumbers(matchTo: string): ValidationErrors {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.parent && c.value) {
        if (!isNaN(c.value)) {
          if (
            !new BigNumber(c.value)
              .isGreaterThanOrEqualTo(new BigNumber(matchTo))
          ) {
            return {
              minNumber: new BigNumber(matchTo)
                .toString(),
            };
          }
        }
      }
      return null;
    };
  }
}
